import { useState, useCallback } from 'react';

const quotes = [
  "The beast does not ask permission.",
  "Desire is the only truth the body knows.",
  "Beneath the lipstick — a confession.",
  "Instinct is not a flaw. It is the original design.",
  "She did not tame the beast. She became it.",
  "Control is the mask. Desire is the face.",
  "The mark you leave is the mark you are.",
  "Beauty is constructed. The beast is real.",
  "In the dark, instinct speaks first.",
  "She wore red not to be seen — but to be felt.",
  "The tiger does not apologise for its stripes.",
  "Elegance is the cage. Desire breaks the lock.",
];

export default function InstinctQuote() {
  const [quote, setQuote] = useState<string | null>(null);
  const [visible, setVisible] = useState(false);
  const [key, setKey] = useState(0);

  const generateQuote = useCallback(() => {
    const next = quotes[Math.floor(Math.random() * quotes.length)];
    setQuote(next);
    setVisible(false);
    setTimeout(() => {
      setVisible(true);
      setKey((k) => k + 1);
    }, 50);
  }, []);

  return (
    <div className="flex flex-col items-center gap-8">
      {/* Quote display */}
      <div className="min-h-[80px] flex items-center justify-center px-6">
        {quote && (
          <p
            key={key}
            className="text-[#EADDCC] text-center font-light italic"
            style={{
              fontFamily: "'Cormorant Garamond', serif",
              fontSize: 'clamp(18px, 2.5vw, 28px)',
              letterSpacing: '0.06em',
              lineHeight: 1.6,
              maxWidth: '600px',
              opacity: visible ? 1 : 0,
              transform: visible ? 'translateY(0)' : 'translateY(12px)',
              transition: 'opacity 0.8s cubic-bezier(0.16,1,0.3,1), transform 0.8s cubic-bezier(0.16,1,0.3,1)',
            }}
          >
            &ldquo;{quote}&rdquo;
          </p>
        )}
      </div>

      {/* Button */}
      <button
        onClick={generateQuote}
        className="group relative px-10 py-3.5 border border-[#EADDCC]/40 text-[#EADDCC]/70 text-xs tracking-widest overflow-hidden cursor-pointer whitespace-nowrap transition-all duration-500 hover:border-[#EADDCC]/80 hover:text-[#EADDCC]"
        style={{ fontFamily: "'Cormorant Garamond', serif", letterSpacing: '0.35em' }}
      >
        <span className="absolute inset-0 bg-[#4D1815]/60 transform -translate-x-full group-hover:translate-x-0 transition-transform duration-500" />
        <span className="relative">GENERATE INSTINCT</span>
      </button>
    </div>
  );
}
